// 'use client';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Autoplay } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import { FaArrowLeft, FaArrowRight, FaQuoteLeft } from 'react-icons/fa6';
// import NextImage from '../Image';

// const TestimonialSection = ({ testimonials }: any) => {
//   return (
//     <section className="testimonial padding-top padding-bottom section-bg-2">
//       <div className="container">
//         {/* Section Header */}
//         <div className="section-header">
//           <div className="section-header__content">
//             <h2>What our customers say</h2>
//           </div>
//           <div className="section-header__action">
//             <div className="swiper-nav swiper-nav--style1">
//               <button className="swiper-nav__btn testimonial-prev">
//                 <FaArrowLeft />
//               </button>
//               <button className="swiper-nav__btn testimonial-next active">
//                 <FaArrowRight />
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Swiper Slider */}
//         <div
//           className="testimonial__wrapper"
//           data-aos="fade-up"
//           data-aos-duration="1000"
//         >
//           <Swiper
//             modules={[Navigation, Autoplay]}
//             navigation={{
//               nextEl: '.testimonial-next',
//               prevEl: '.testimonial-prev',
//             }}
//             loop={true}
//             spaceBetween={30}
//             breakpoints={{
//               320: { slidesPerView: 1 },
//               768: { slidesPerView: 2.5 },
//               992: { slidesPerView: 2.5 },
//             }}
//             className="testimonial__slider"
//           >
//             {testimonials
//               .filter((testimonial: any) => testimonial.comment)
//               .map((testimonial: any, index: number) => (
//                 <SwiperSlide key={index}>
//                   <div className="testimonial__item testimonial__item--style1">
//                     <div className="testimonial__item-inner">
//                       <div className="testimonial__item-content">
//                         <div className="testimonial__quote">
//                           <span>
//                             <FaQuoteLeft />
//                           </span>
//                         </div>
//                         <p className="mb-0">{testimonial?.comment}</p>
//                         <div className="testimonial__footer">
//                           <div className="testimonial__author">
//                             <div className="testimonial__author-thumb">
//                               <NextImage
//                                 src={
//                                   testimonial?.avatar ||
//                                   '/images/icon/demo-person.jpg'
//                                 }
//                                 alt={'User Avatar'}
//                                 width={80}
//                                 height={80}
//                                 className="rounded-circle"
//                               />
//                             </div>
//                             <div className="testimonial__author-designation">
//                               <h6>{testimonial?.user_name}</h6>
//                               {/* <span>{testimonial?.time}</span> */}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </SwiperSlide>
//               ))}
//           </Swiper>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default TestimonialSection;

// src/features/testimonial/Testimonial.tsx

// NO 'use client'. This is a Server Component.
'use client';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';
import { TestimonialSlider } from './TestimonialSlider'; // Import the new client component
import { TestimonialSkeleton } from './TestimonialSkeleton';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { API_HOME_THINGS } from '@/constant/apiRout';
// The component is now ASYNC
const TestimonialSection = () => {
  const { data: homeThings, isLoading } = useFetcherCSR(API_HOME_THINGS);
  // ✅ DATA IS FETCHED HERE, INSIDE THE COMPONENT

  const allTestimonials = homeThings?.reviews ?? [];

  // Filter for testimonials that have a comment, just like in the original code
  const testimonials = allTestimonials.filter((t: any) => t.comment);

  if (isLoading) return <TestimonialSkeleton />;

  homeThings?.homepage_settings?.features?.recommendation;
  if (
    testimonials.length === 0 ||
    !homeThings?.homepage_settings?.features?.reviews
  ) {
    return null;
  }

  return (
    <section className="testimonial padding-top padding-bottom section-bg-2">
      <div className="container">
        {/* This header is now static HTML rendered on the server */}
        <div className="section-header">
          <div className="section-header__content">
            <h2>What our customers say</h2>
          </div>
          <div className="section-header__action">
            <div className="swiper-nav swiper-nav--style1">
              <button className="swiper-nav__btn testimonial-prev">
                <FaArrowLeft />
              </button>
              <button className="swiper-nav__btn testimonial-next active">
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>

        {/* ✅ REMOVED the data-aos wrapper */}
        <div className="testimonial__wrapper">
          {/* Pass the server-fetched data to the client slider */}
          <TestimonialSlider testimonials={testimonials} />
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
